document.addEventListener("DOMContentLoaded", function () {
  var actionButton = document.querySelector(".action-button");
  var closeButton = document.querySelector(".close-button");
  var videoPopup = document.querySelector(".video-popup");
  var videoEmbeds = document.querySelectorAll(".video-embed");

  var videoUrls = [
    "https://www.youtube.com/embed/kdFiuIO2Ofw?enablejsapi=1",
    "https://www.youtube.com/embed/0BdcSnuNkwM?enablejsapi=1",
  ];

  if (actionButton) {
    actionButton.addEventListener("click", function () {
      if (videoPopup) {
        videoPopup.style.display = "block";
      }
      if (videoEmbeds.length > 2) {
        videoEmbeds[0].src = videoUrls[0];
        videoEmbeds[1].src = videoUrls[1];
      }
    });
  }

  if (closeButton) {
    closeButton.addEventListener("click", closePopup);
  }

  if (videoPopup) {
    videoPopup.addEventListener("click", function (event) {
      if (event.target === videoPopup) {
        closePopup();
      }
    });
  }

  function closePopup() {
    if (videoPopup) {
      videoPopup.style.display = "none";
    }
    if (videoEmbeds.length > 2) {
      videoEmbeds[0].src = "";
      videoEmbeds[1].src = "";
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var actionButtonSecond = document.querySelector(".action-button-second");
  var closeButtonSecond = document.querySelector(".close-button-second");
  var videoPopupSecond = document.querySelector(".video-popup-second");
  var videoEmbedSecond = document.querySelector(".video-embed-second");

  // Adjust with your second video's URL
  var videoUrlSecond = "https://www.youtube.com/embed/QoaOd-R5nHA?si=isOPbzRuwdtpensw";

  if (actionButtonSecond) {
    actionButtonSecond.addEventListener("click", function () {
      if (videoPopupSecond || videoEmbedSecond) {
        videoPopupSecond.style.display = "block";
        videoEmbedSecond.src = videoUrlSecond + "?autoplay=1"; // Autoplay the video
      }
    });
  }

  if (closeButtonSecond) {
    closeButtonSecond.addEventListener("click", function () {
      if (videoPopupSecond || videoEmbedSecond) {
        videoPopupSecond.style.display = "none";
        videoEmbedSecond.src = ""; // Stop the video from playing
      }
    });
  }

  // Close the popup when clicking outside of it
  if (videoPopupSecond) {
    videoPopupSecond.addEventListener("click", function (event) {
      if (event.target === videoPopupSecond) {
        if (videoPopupSecond || videoEmbedSecond) {
          videoPopupSecond.style.display = "none";
          videoEmbedSecond.src = ""; // Stop the video from playing
        }
      }
    });
  }
});

